import { render } from "./AdminXePhanCong.vue?vue&type=template&id=8ea84602&scoped=true"
import script from "./AdminXePhanCong.vue?vue&type=script&lang=js"
export * from "./AdminXePhanCong.vue?vue&type=script&lang=js"

import "./AdminXePhanCong.vue?vue&type=style&index=0&id=8ea84602&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ea84602"]])

export default __exports__